import { Build } from "@stencil/core";
let missingAssetPathWarning = false;
/**
 *
 * Reads the component asset path config from meta tag or a global variable.
 * This is a temporary workaround until these issues have been addressed:
 *
 * https://github.com/ionic-team/stencil/issues/2826/
 * https://github.com/ionic-team/stencil/issues/3470
 * https://github.com/ionic-team/stencil-ds-output-targets/issues/186
 */
export const getAssetPath = (path) => {
    var _a;
    const metaPineAssetPath = (_a = document.head.querySelector('meta[data-pine-asset-path]')) === null || _a === void 0 ? void 0 : _a.dataset.pineAssetPath;
    // Get the asset path from the window object if available
    const windowAssetPath = window.__PINE_ASSET_PATH__;
    // Set the CDN Asset path using the latest version
    const cdnAssetPath = 'https://cdn.jsdelivr.net/npm/@pine-ds/icons/dist/pds-icons/';
    const assetBasePath = Build.isTesting ? '/dist/pds-icons' : metaPineAssetPath || windowAssetPath || cdnAssetPath || '/';
    // Display a warning if the assets are fetched from the CDN.
    if (assetBasePath.startsWith('https://cdn.jsdelivr.net/npm/') && !missingAssetPathWarning) {
        missingAssetPathWarning = true;
        console.warn(`
      Fetching Pine asssets from jsDelivr CDN.\n\n It's recommended that you bundle Pine Assets with your application and setting the path accordingly.\n\nFor more information you read the documentation: \nhttps://pine-design-system.netlify.app/?path=/docs/resources-assets--docs
    `);
    }
    let assetPath = path;
    if (path.startsWith('./')) {
        assetPath = path.substring(2);
    }
    if (!assetBasePath.endsWith('/')) {
        assetPath = '/' + assetPath;
    }
    return assetBasePath + assetPath;
};
//# sourceMappingURL=assetPath.js.map
